// src/shoeData.js

const products = [
  {
    _id: '1',
    name: "Air Max Revolution",
    price: 129.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-665455a5-45de-40fb-945f-c1852b82400d/react-infinity-run-flyknit-mens-running-shoe-zX42Nc.jpg",
    rating: 4.5,
    description: "Premium running shoes with advanced cushioning technology"
  },
  {
    _id: '2',
    name: "Classic Leather Boots",
    price: 199.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-5cc7de3b-2afc-49c2-a1e4-0508997d09e6/react-miler-mens-running-shoe-DgF6nr.jpg",
    rating: 4.8,
    description: "Handcrafted leather boots for style and durability"
  },
  {
    _id: '3',
    name: "Urban Sneakers",
    price: 89.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-33b0a0a5-c171-46cc-ad20-04a768703e47/air-zoom-pegasus-37-womens-running-shoe-Jl0bDf.jpg",
    rating: 4.3,
    description: "Comfortable casual sneakers for everyday wear"
  },
  {
    _id: '4',
    name: "Professional Oxford",
    price: 159.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/99a7d3cb-e40c-4474-91c2-0f2e6d231fd2/joyride-run-flyknit-womens-running-shoe-HcfnJd.jpg",
    rating: 4.7,
    description: "Elegant dress shoes for professional occasions"
  },
  {
    _id: '5',
    name: "Sport Runner Pro",
    price: 149.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/9dda6202-e2ff-4711-9a09-0fcb7d90c164/mercurial-vapor-13-elite-fg-firm-ground-soccer-cleat-14MsF2.jpg",
    rating: 4.6,
    description: "High-performance running shoes for athletes"
  },
  {
    _id: '6',
    name: "Casual Canvas",
    price: 59.99,
    image: "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/s1amp7uosrn0nqpsxeue/phantom-vision-elite-dynamic-fit-fg-firm-ground-soccer-cleat-19Kv1V.jpg",
    rating: 4.2,
    description: "Lightweight canvas shoes for casual outings"
  },
    {
    "_id": "7",
    "name": "Casual Canvas 7",
    "price": 63.04,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/whegph8z9ornhxklc8rp/phantom-venom-academy-fg-firm-ground-soccer-cleat-6JVNll.jpg",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "8",
    "name": "Casual Canvas 8",
    "price": 31.12,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/vhbwnkor8sxt8qtecgia/mercurial-vapor-13-elite-tech-craft-fg-firm-ground-soccer-cleat-l38JPj.jpg",
    "rating": 4.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "9",
    "name": "Casual Canvas 9",
    "price": 98.22,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-a52a8aec-22dc-4982-961b-75c5f4c72805/mercurial-superfly-7-pro-mds-fg-firm-ground-soccer-cleat-mhcpdN.jpg",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "10",
    "name": "Casual Canvas 10",
    "price": 66.96,
    "image": "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/178b2a46-3ee4-492b-882e-f71efdd53a36/air-force-1-big-kids-shoe-2zqp8D.jpg",
    "rating": 3.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "11",
    "name": "Casual Canvas 11",
    "price": 59.05,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/8439f823-86cf-4086-81d2-4f9ff9a66866/air-max-90-big-kids-shoe-1wzwJM.jpg",
    "rating": 3.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "12",
    "name": "Casual Canvas 12",
    "price": 91.68,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-620aeb37-1b28-44b0-9b14-5572f8cbc948/air-max-90-ltr-big-kids-shoe-hdNLQ5.jpg",
    "rating": 3.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "13",
    "name": "Casual Canvas 13",
    "price": 72.19,
    "image": "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/33888130-0320-41a1-ba53-a026decd8aa2/joyride-dual-run-big-kids-running-shoe-1HDJF8.jpg",
    "rating": 3.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "14",
    "name": "Casual Canvas 14",
    "price": 35.63,
    "image": "https://static.nike.com/a/images/c_limit,w_592,f_auto/t_product_v1/i1-73e54c0b-11a6-478b-9f90-bd97fcde872d/renew-run-big-kids-running-shoe-5Bpz93.jpg",
    "rating": 4.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
    {
    "_id": "26",
    "name": "Casual Canvas 26",
    "price": 83.4,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/ef901c7aeac042578eceab9d0159196c_9366/Nizza_x_Disney_Sport_Goofy_Shoes_White_FW0651_01_standard.jpg",
    "rating": 4.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "27",
    "name": "Casual Canvas 27",
    "price": 87.96,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/a36518227134495da766ab9d01772fa2_9366/X_PLR_Shoes_Red_FY9063_01_standard.jpg",
    "rating": 4.7,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "28",
    "name": "Casual Canvas 28",
    "price": 44.09,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/d0720712d81e42b1b30fa80800826447_9366/Stan_Smith_Shoes_White_M20607_M20607_01_standard.jpg",
    "rating": 3.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "29",
    "name": "Casual Canvas 29",
    "price": 86.2,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/99ca762cb9054caf82fbabc500fd146e_9366/NMD_R1_Shoes_Blue_FY9392_01_standard.jpg",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "30",
    "name": "Casual Canvas 30",
    "price": 57.34,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/90f85768e3894aeaab67aba0014a3379_9366/NMD_R1_Shoes_Red_FY9389_01_standard.jpg",
    "rating": 4.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "31",
    "name": "Casual Canvas 31",
    "price": 71.03,
    "image": "https://assets.adidas.com/images/h_320,f_auto,q_auto:sensitive,fl_lossy/12365dbc7c424288b7cdab4900dc7099_9366/Superstar_Shoes_White_FW3553_FW3553_01_standard.jpg",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "35",
    "name": "Casual Canvas 35",
    "price": 64.23,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=35",
    "rating": 3.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "36",
    "name": "Casual Canvas 36",
    "price": 35.15,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=36",
    "rating": 3.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "37",
    "name": "Casual Canvas 37",
    "price": 92.19,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=37",
    "rating": 3.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "38",
    "name": "Casual Canvas 38",
    "price": 99.9,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=38",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "39",
    "name": "Casual Canvas 39",
    "price": 49.54,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=39",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "40",
    "name": "Casual Canvas 40",
    "price": 76.05,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=40",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "41",
    "name": "Casual Canvas 41",
    "price": 42.25,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=41",
    "rating": 4.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "42",
    "name": "Casual Canvas 42",
    "price": 48.62,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=42",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "43",
    "name": "Casual Canvas 43",
    "price": 96.68,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=43",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "44",
    "name": "Casual Canvas 44",
    "price": 38.41,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=44",
    "rating": 3.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "45",
    "name": "Casual Canvas 45",
    "price": 65.21,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=45",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "46",
    "name": "Casual Canvas 46",
    "price": 59.83,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=46",
    "rating": 3.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "47",
    "name": "Casual Canvas 47",
    "price": 92.53,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=47",
    "rating": 5.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "48",
    "name": "Casual Canvas 48",
    "price": 32.52,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=48",
    "rating": 4.7,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "49",
    "name": "Casual Canvas 49",
    "price": 42.48,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=49",
    "rating": 3.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "50",
    "name": "Casual Canvas 50",
    "price": 58.9,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=50",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "51",
    "name": "Casual Canvas 51",
    "price": 95.83,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=51",
    "rating": 4.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "52",
    "name": "Casual Canvas 52",
    "price": 60.18,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=52",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "53",
    "name": "Casual Canvas 53",
    "price": 99.78,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=53",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "54",
    "name": "Casual Canvas 54",
    "price": 56.87,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=54",
    "rating": 3.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "55",
    "name": "Casual Canvas 55",
    "price": 45.98,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=55",
    "rating": 3.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "56",
    "name": "Casual Canvas 56",
    "price": 65.24,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=56",
    "rating": 4.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "57",
    "name": "Casual Canvas 57",
    "price": 52.34,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=57",
    "rating": 4.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "58",
    "name": "Casual Canvas 58",
    "price": 87.32,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=58",
    "rating": 4.7,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "59",
    "name": "Casual Canvas 59",
    "price": 43.44,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=59",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "60",
    "name": "Casual Canvas 60",
    "price": 83.15,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=60",
    "rating": 4.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "61",
    "name": "Casual Canvas 61",
    "price": 83.58,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=61",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "62",
    "name": "Casual Canvas 62",
    "price": 63.83,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=62",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "63",
    "name": "Casual Canvas 63",
    "price": 77.25,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=63",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "64",
    "name": "Casual Canvas 64",
    "price": 56.75,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=64",
    "rating": 4.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "65",
    "name": "Casual Canvas 65",
    "price": 61.95,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=65",
    "rating": 3.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "66",
    "name": "Casual Canvas 66",
    "price": 41.4,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=66",
    "rating": 4.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "67",
    "name": "Casual Canvas 67",
    "price": 36.08,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=67",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "68",
    "name": "Casual Canvas 68",
    "price": 88.85,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=68",
    "rating": 3.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "69",
    "name": "Casual Canvas 69",
    "price": 38.94,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=69",
    "rating": 3.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "70",
    "name": "Casual Canvas 70",
    "price": 66.91,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=70",
    "rating": 4.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "71",
    "name": "Casual Canvas 71",
    "price": 32.23,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=71",
    "rating": 4.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "72",
    "name": "Casual Canvas 72",
    "price": 39.8,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=72",
    "rating": 4.7,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "73",
    "name": "Casual Canvas 73",
    "price": 43.97,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=73",
    "rating": 4.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "74",
    "name": "Casual Canvas 74",
    "price": 83.44,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=74",
    "rating": 4.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "75",
    "name": "Casual Canvas 75",
    "price": 54.86,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=75",
    "rating": 3.9,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "76",
    "name": "Casual Canvas 76",
    "price": 30.08,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=76",
    "rating": 5.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "77",
    "name": "Casual Canvas 77",
    "price": 80.25,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=77",
    "rating": 4.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "78",
    "name": "Casual Canvas 78",
    "price": 72.7,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=78",
    "rating": 3.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "79",
    "name": "Casual Canvas 79",
    "price": 47.58,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=79",
    "rating": 3.1,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "80",
    "name": "Casual Canvas 80",
    "price": 34.61,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=80",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "81",
    "name": "Casual Canvas 81",
    "price": 87.97,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=81",
    "rating": 3.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "82",
    "name": "Casual Canvas 82",
    "price": 33.05,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=82",
    "rating": 3.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "83",
    "name": "Casual Canvas 83",
    "price": 41.81,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=83",
    "rating": 4.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "84",
    "name": "Casual Canvas 84",
    "price": 40.07,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=84",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "85",
    "name": "Casual Canvas 85",
    "price": 37.67,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=85",
    "rating": 4.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "86",
    "name": "Casual Canvas 86",
    "price": 64.3,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=86",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "87",
    "name": "Casual Canvas 87",
    "price": 31.1,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=87",
    "rating": 4.3,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "88",
    "name": "Casual Canvas 88",
    "price": 59.95,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=88",
    "rating": 3.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "89",
    "name": "Casual Canvas 89",
    "price": 42.15,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=89",
    "rating": 3.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "90",
    "name": "Casual Canvas 90",
    "price": 53.98,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=90",
    "rating": 3.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "91",
    "name": "Casual Canvas 91",
    "price": 61.17,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=91",
    "rating": 3.2,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "92",
    "name": "Casual Canvas 92",
    "price": 42.1,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=92",
    "rating": 3.5,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "93",
    "name": "Casual Canvas 93",
    "price": 78.61,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=93",
    "rating": 4.4,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "94",
    "name": "Casual Canvas 94",
    "price": 91.57,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=94",
    "rating": 4.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "95",
    "name": "Casual Canvas 95",
    "price": 57.86,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=95",
    "rating": 4.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "96",
    "name": "Casual Canvas 96",
    "price": 60.59,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=96",
    "rating": 3.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "97",
    "name": "Casual Canvas 97",
    "price": 33.53,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=97",
    "rating": 3.6,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "98",
    "name": "Casual Canvas 98",
    "price": 87.13,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=98",
    "rating": 3.0,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "99",
    "name": "Casual Canvas 99",
    "price": 51.46,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=99",
    "rating": 3.8,
    "description": "Lightweight canvas shoes for casual outings"
  },
  {
    "_id": "100",
    "name": "Casual Canvas 100",
    "price": 73.75,
    "image": "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400&h=400&sig=100",
    "rating": 4.0,
    "description": "Lightweight canvas shoes for casual outings"
  }
];

export default products;
